/** Nav bar placeholders for full-screen loading states. */

import { spacings } from 'component/constants';

import { BaseSkeleton } from './base-skeleton';
import { SkeletonNavBar } from './skeleton-nav-bar';
import { TextContainerSkeleton } from './text-container-skeleton';

export type NavBarSkeletonProps = {
    large: boolean;
    /** Off for routes whose stack sets `headerRight` to null, such as login. */
    withAvatar?: boolean;
};

// Placeholder for the top-level nav bar. Shows skeleton shapes rather than the
// real SiteLogo/UserInfo: those depend on the datastore, so gating them on it
// flashed a logged-out state for logged-in users on slow networks before the
// data arrived.
export function NavBarSkeleton({ large, withAvatar = true }: NavBarSkeletonProps) {
    return (
        <SkeletonNavBar paddingHorizontal={large ? spacings.xl4 : spacings.lg}>
            <TextContainerSkeleton borderRadius={4} height={24} width={100} />
            {withAvatar && <BaseSkeleton borderRadius={16} height={32} width={32} />}
        </SkeletonNavBar>
    );
}

/** Placeholder for a host panel's nav bar: a close control and an avatar. */
export function SidebarNavBarSkeleton() {
    return (
        <SkeletonNavBar paddingHorizontal={spacings.lg}>
            <BaseSkeleton borderRadius={4} height={32} width={32} />
            <BaseSkeleton borderRadius={16} height={32} width={32} />
        </SkeletonNavBar>
    );
}
